import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChildProfessionsComponent } from './child-professions.component';

const routes: Routes = [
  { path: '', component: ChildProfessionsComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChildProfessionsRoutingModule { }
